export const getSubcategoryDivisions = state => state.subcategoryDivisions.data;
export const getSelectedSubcategoryDivision = state =>
  state.subcategoryDivisions.selectedDivision;
